import IAddinCommand from './schema/interfaces/IAddinCommand';
import ExtensibilityState from './schema/ExtensibilityState';
import TaskPaneRunningInstance from './schema/TaskPaneRunningInstance';
import { createHiddenSsoDialog } from './schema/interfaces/ActiveSsoDialog';
import { createStore } from 'satcheljs';
import { ExtensibilityHostItem } from './schema/ExtensibilityHostItem';
import { initializeCompliance } from './schema/Compliance';
import { InitializeContextualCalloutState } from './schema/ContextualCalloutState';
import { ObservableMap } from 'mobx';
import IAutoRunAddinCommand from './schema/interfaces/IAutoRunAddinCommand';

const store: ExtensibilityState = createStore<ExtensibilityState>('extensibility', {
    EnabledAddinCommands: null,
    HostItems: new ObservableMap<string, ExtensibilityHostItem>(),
    IsPreinstalledTeachingUIAvailable: false,
    Context: null,
    taskPanes: new ObservableMap<string, TaskPaneRunningInstance>(),
    activeDialog: null,
    activeSsoDialog: createHiddenSsoDialog(),
    ExtensibilityStateIsDirty: false,
    contextualCalloutState: InitializeContextualCalloutState(),
    runningContextualAddinCommand: null,
    runningUILessAddinCommands: new ObservableMap<string, ObservableMap<string, IAddinCommand>>(),
    blockedAddinCommands: new ObservableMap<string, Set<IAddinCommand>>(),
    autoRunAddinCommandWaitingQueue: new ObservableMap<string, Array<IAutoRunAddinCommand>>(),
    compliance: initializeCompliance(),
})();

export default store;
